import { Box, Container, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArrowLink } from "../ui/primitives";
import { colors } from "../ui/tokens";
import ProjectLinks from "./ProjectLinks";
import { projectPath } from "../data/projects";

// Full-width band for one of our own products. OXIPOS and Posa use the same
// layout so they carry equal weight; each keeps its own brand colours.
export default function ProductFeature({ project, reverse = false }) {
  const { t } = useTranslation("HomePage");
  const k = (key) => t(`products.${project.key}.${key}`);
  const { accent, surface, block } = project.brand;

  return (
    <Box component="section" id={project.key} sx={{ backgroundColor: surface, color: colors.onDark, py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center" direction={{ xs: "column-reverse", md: reverse ? "row-reverse" : "row" }}>
          <Grid item xs={12} md={7} sx={{ width: "100%" }}>
            <Typography sx={{ fontSize: "0.78rem", fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: accent, mb: 2 }}>
              {k("eyebrow")}
            </Typography>
            <Typography variant="h2" component="h2" sx={{ color: colors.onDark }}>
              {k("title")}
            </Typography>
            <Typography sx={{ mt: 2.5, color: colors.onDarkMuted, fontSize: { xs: "1.02rem", md: "1.12rem" }, lineHeight: 1.7, maxWidth: 620 }}>
              {k("lead")}
            </Typography>

            <Grid container sx={{ mt: { xs: 4, md: 5 }, borderTop: `1px solid ${colors.lineDark}` }}>
              {["f1", "f2", "f3", "f4"].map((f, i) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  key={f}
                  sx={{
                    py: { xs: 2.5, md: 3 },
                    pr: { sm: i % 2 === 0 ? 4 : 0 },
                    pl: { sm: i % 2 === 1 ? 4 : 0 },
                    borderBottom: `1px solid ${colors.lineDark}`,
                    borderLeft: { sm: i % 2 === 1 ? `1px solid ${colors.lineDark}` : "none" },
                  }}
                >
                  <Typography sx={{ fontWeight: 700, color: colors.onDark, mb: 0.75 }}>{k(`${f}.title`)}</Typography>
                  <Typography sx={{ color: colors.onDarkMuted, fontSize: "0.95rem" }}>{k(`${f}.body`)}</Typography>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ mt: { xs: 4, md: 5 } }}>
              <ProjectLinks links={project.links} dark />
            </Box>
            <Box sx={{ mt: 4 }}>
              <ArrowLink to={projectPath(project)} dark>{k("more")}</ArrowLink>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ width: "100%" }}>
            <Box
              component="img"
              src={block}
              alt={t(`products.${project.key}.alt`)}
              loading="lazy"
              sx={{ width: "100%", maxWidth: { xs: 360, md: 460 }, mx: "auto", borderRadius: "18px" }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
